import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { LoyaltyEventAction } from '~constants/Loyalty';

export class LoyaltyBenefitsUseCase {
    private eventRepository: EventRepository;
    private loyaltyPayloadData: string;
    private loyaltyBenefitsEventData: string;

    constructor(loyaltyPayloadData: string, loyaltyBenefitsEventData: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.loyaltyPayloadData = loyaltyPayloadData;
        this.loyaltyBenefitsEventData = loyaltyBenefitsEventData;
    }

    public execute() {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.loyaltyBenefitsEventData,
            type: 'link',
            payload: this.getAccountLoyaltyBenefitsInfoPayload()
        });
        this.eventRepository.addEventToQueue(newEvent);
    }

    private getAccountLoyaltyBenefitsInfoPayload() {
        return {
            event_name: LoyaltyEventAction.LOYALTY_EVENT_PAGE,
            event_category: LoyaltyEventAction.LOYALTY_EVENT_PAGE,
            event_action: LoyaltyEventAction.LOYALTY_BENEFITS_TEXT,
            event_label: this.loyaltyPayloadData
        };
    }
}
